module.exports = __webpack_public_path__ + "media/images/weather/119_night-cc5d16bab4ec94b417b22782e2d2d4c7.png";